import { ChangeEvent, forwardRef } from 'react';
import { Box, Link, Stack, TextField, TextFieldProps, Typography, styled } from '@mui/material';
import { UploadFile } from '@mui/icons-material';
import './file-input.scss';

const FileInputError = styled(TextField)<TextFieldProps>(() => ({
	'& .MuiInputBase-root': {
		display: 'none',
	},
}));

interface FileInputProps {
	id: string;
	name: string;
	accept?: string;
	acceptReadable?: string;
	onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
	error?: string;
}

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
	({ id, name, accept, acceptReadable, onChange, error }, ref) => (
		<Box component="label" className="file-input-wrapper">
			<Box component="div" className="file-input-container">
				<Stack direction="column" alignItems="center" spacing={1}>
					<Stack
						component="div"
						className="file-input-icon-container"
						alignItems="center"
						justifyContent="center"
					>
						<UploadFile color="primary" />
					</Stack>
					<Typography>
						<Typography component={Link}>Click to upload</Typography> or drag and drop
					</Typography>
					<Typography color="text.secondary" variant="body2">
						{acceptReadable}
					</Typography>
					<input type="file" {...{ id, name, accept, onChange }} ref={ref} />
				</Stack>
			</Box>
			<FileInputError error={!!error} helperText={error} />
		</Box>
	)
);

export default FileInput;
